module.exports = __webpack_public_path__ + "img/lisa_d.2f71d9b2.png";